<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 179 180"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>primary-grocery-shoppers</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <circle
        id="path-1"
        cx="90"
        cy="90"
        r="90" />
    </defs>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-897.000000, -230.000000)">
        <g
          id="primary-grocery-shoppers"
          transform="translate(897.000000, 230.000000)">
          <mask
            id="mask-2"
            fill="white">
            <use xlink:href="#path-1" />
          </mask>
          <g
            id="Oval"
            fill-rule="nonzero" />
          <g
            id="Background"
            mask="url(#mask-2)">
            <g
              id="New_Symbol_46-20"
              transform="translate(-10.250000, 0.000000)">
              <g>
                <path
                  id="Path"
                  d="M188.382561,90.3825 C188.379058,53.6278739 166.026538,20.5683915 131.918936,6.87262295 C97.8113349,-6.8231456 58.8028147,1.59706088 33.3814976,28.1424783 C7.96018042,54.6878956 1.23465899,94.0240353 16.3925,127.5075 L180.35,127.5075 C185.6581,115.851475 188.397527,103.190256 188.382561,90.3825 L188.382561,90.3825 Z"
                  class="fill-extra-light"
                  fill-rule="nonzero" />
                <line
                  id="Path"
                  x1="10.6325"
                  y1="127.5075"
                  x2="186.1325"
                  y2="127.5075"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </g>
            </g>
          </g>
          <g
            id="Scene"
            mask="url(#mask-2)">
            <g transform="translate(-3.500000, 22.500000)">
              <path
                id="Path"
                d="M120.905,0.4275 L120.905,0.4275 C105.993312,0.4275 93.905,12.5158118 93.905,27.4275 L93.905,54.4275 C93.905,61.8833441 99.9491559,67.9275 107.405,67.9275 L134.405,67.9275 C141.860844,67.9275 147.905,61.8833441 147.905,54.4275 L147.905,27.4275 C147.905,12.5158118 135.816688,0.4275 120.905,0.4275 L120.905,0.4275 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M120.905,0.4275 L120.905,0.4275 C105.993312,0.4275 93.905,12.5158118 93.905,27.4275 L93.905,54.4275 C93.905,61.8833441 99.9491559,67.9275 107.405,67.9275 L134.405,67.9275 C141.860844,67.9275 147.905,61.8833441 147.905,54.4275 L147.905,27.4275 C147.905,12.5158118 135.816688,0.4275 120.905,0.4275 L120.905,0.4275 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <g
                id="Group"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
                transform="translate(0.000000, 40.250000)">
                <path
                  id="Path"
                  d="M142.2575,67.0075 L153.5075,67.0075 C154.750141,67.0075 155.7575,66.0001407 155.7575,64.7575 L155.7575,60.2575 C155.745232,44.0440684 144.554056,29.9804904 128.7575,26.3275 L128.7575,18.6325 L113.0075,18.6325 L113.0075,26.3275 C97.2062398,29.9730337 86.0114454,44.0411588 86.0075,60.2575 L86.0075,64.7575 C86.0075,66.0001407 87.0148593,67.0075 88.2575,67.0075 L99.5075,67.0075 L99.5075,90.6325 L102.8825,121.0075 L140.0075,121.0075 L142.2575,90.6325 L142.2575,67.0075 Z"
                  class="fill-white"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M142.2575,67.0075 L153.5075,67.0075 C154.750141,67.0075 155.7575,66.0001407 155.7575,64.7575 L155.7575,60.2575 C155.745232,44.0440684 144.554056,29.9804904 128.7575,26.3275 L128.7575,18.6325 L113.0075,18.6325 L113.0075,26.3275 C97.2062398,29.9730337 86.0114454,44.0411588 86.0075,60.2575 L86.0075,64.7575 C86.0075,66.0001407 87.0148593,67.0075 88.2575,67.0075 L99.5075,67.0075 L99.5075,90.6325 L102.8825,121.0075 L140.0075,121.0075 L142.2575,90.6325 L142.2575,67.0075 Z"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <line
                  id="Path"
                  x1="78.1325"
                  y1="32.1325"
                  x2="73.6325"
                  y2="53.5075"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round" />
                <rect
                  id="Rectangle"
                  class="stroke fill-light"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  x="38.7575"
                  y="22.0075"
                  width="18"
                  height="31.5" />
                <rect
                  id="Rectangle"
                  class="fill-light"
                  fill-rule="nonzero"
                  x="21.8825"
                  y="16.3825"
                  width="20.25"
                  height="37.125" />
                <rect
                  id="Rectangle"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linejoin="round"
                  x="21.8825"
                  y="16.3825"
                  width="20.25"
                  height="37.125" />
                <polygon
                  id="Path"
                  class="fill-light"
                  fill-rule="nonzero"
                  points="73.6325 53.5075 52.2575 53.5075 55.6325 17.5075 70.2575 17.5075" />
                <polygon
                  id="Path"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linejoin="round"
                  points="73.6325 53.5075 52.2575 53.5075 55.6325 17.5075 70.2575 17.5075" />
                <line
                  id="Path"
                  x1="63.5075"
                  y1="32.1325"
                  x2="63.5075"
                  y2="53.5075"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round" />
                <line
                  id="Path"
                  x1="48.8825"
                  y1="32.1325"
                  x2="48.8825"
                  y2="53.5075"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round" />
                <line
                  id="Path"
                  x1="34.2575"
                  y1="32.1325"
                  x2="34.2575"
                  y2="53.5075"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round" />
                <path
                  id="Path"
                  d="M83.7575,29.8825 C83.7575,31.1251407 82.7501407,32.1325 81.5075,32.1325 L18.5075,32.1325 L18.5075,27.6325 L81.5075,27.6325 C82.7501407,27.6325 83.7575,28.6398593 83.7575,29.8825 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round" />
                <path
                  id="Path"
                  d="M75.8825,55.7575 C75.8825,57.0001407 74.8751407,58.0075 73.6325,58.0075 L18.5075,58.0075 L18.5075,53.5075 L73.6325,53.5075 C74.8751407,53.5075 75.8825,54.5148593 75.8825,55.7575 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round" />
                <path
                  id="Path"
                  d="M78.1325,43.3825 C78.1325,44.6251407 77.1251407,45.6325 75.8825,45.6325 L18.5075,45.6325 L18.5075,41.1325 L75.8825,41.1325 C77.1251407,41.1325 78.1325,42.1398593 78.1325,43.3825 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  stroke-linecap="round" />
                <path
                  id="Path"
                  d="M57.8825,17.5075 L60.425,1.7575 C60.664844,0.769777122 61.5371063,0.065506094 62.5531913,0.0391826488 C63.5692762,0.0128592037 64.4768347,0.671020885 64.7675,1.645 L68.0075,17.5075"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M26.945,19.7575 L26.945,11.32 C26.945,8.52405845 29.2115585,6.2575 32.0075,6.2575 C34.8034415,6.2575 37.07,8.52405845 37.07,11.32 L37.07,19.7575"
                  class="stroke"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <ellipse
                  id="Oval"
                  class="fill-extra-light"
                  fill-rule="nonzero"
                  cx="53.3825"
                  cy="81.6325"
                  rx="31.5"
                  ry="3.375" />
                <path
                  id="Path"
                  d="M82.6325,71.5075 C82.6325,72.7501407 81.6251407,73.757622 80.3825,73.757622 L28.925,73.757622 C23.1102351,73.7843508 18.2331614,69.3754761 17.675,63.5875 L14.48,29.5 C14.262412,27.184507 12.8681431,25.1441136 10.79,24.1 L1.79,19.6 C1.04449272,19.257568 0.544454101,18.5365136 0.485057371,17.718276 C0.425660641,16.9000384 0.816321552,16.1143271 1.50455877,15.6678181 C2.19279599,15.2213091 3.06950808,15.1847843 3.7925,15.5725 L12.7925,20.0725 C16.2618715,21.8088057 18.5918085,25.2101736 18.9575,29.0725 L22.22,63.25 C22.5570704,66.7210023 25.4827078,69.3638281 28.97,69.3475 L80.3825,69.3475 C81.5908255,69.346533 82.5841674,70.3001412 82.6325,71.5075 Z"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero" />
                <circle
                  id="Oval"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  cx="34.2575"
                  cy="76.5925"
                  r="4.5" />
                <circle
                  id="Oval"
                  class="stroke fill-white"
                  stroke-width="2.25"
                  fill-rule="nonzero"
                  cx="71.3825"
                  cy="76.5925"
                  r="4.5" />
              </g>
              <path
                id="Path"
                d="M128.7575,66.5775 L128.7575,58.8825 L113.0075,58.8825 L113.0075,66.5775 C111.008459,67.0277152 109.05707,67.6681322 107.18,68.49 C109.303336,74.2152954 114.764896,78.0148352 120.87125,78.0148352 C126.977604,78.0148352 132.439164,74.2152954 134.5625,68.49 C132.693161,67.6682013 130.749244,67.0277634 128.7575,66.5775 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M128.7575,66.5775 L128.7575,58.8825 L113.0075,58.8825 L113.0075,66.5775 C111.008459,67.0277152 109.05707,67.6681322 107.18,68.49 C109.303336,74.2152954 114.764896,78.0148352 120.87125,78.0148352 C126.977604,78.0148352 132.439164,74.2152954 134.5625,68.49 C132.693161,67.6682013 130.749244,67.0277634 128.7575,66.5775 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M143.405,35.3025 L143.405,29.6775 C143.405,29.16 143.405,28.6425 143.405,28.125 C132.94528,33.4507586 120.183271,30.6972469 112.85,21.5325 C111.880012,27.5168737 106.717467,31.91742 100.655,31.9275 C99.900333,31.9301537 99.1470658,31.8623596 98.405,31.725 L98.405,35.3025 C95.9197186,35.3025 93.905,37.3172186 93.905,39.8025 C93.905,42.2877814 95.9197186,44.3025 98.405,44.3025 L98.675,44.3025 C100.417851,55.2216484 109.836385,63.2560724 120.89375,63.2560724 C131.951115,63.2560724 141.369649,55.2216484 143.1125,44.3025 L143.405,44.3025 C145.890281,44.3025 147.905,42.2877814 147.905,39.8025 C147.905,37.3172186 145.890281,35.3025 143.405,35.3025 L143.405,35.3025 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M114.11,50.6025 C117.903497,54.168598 123.816503,54.168598 127.61,50.6025"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M133.28,37.5525 C132.704399,36.1989677 131.375838,35.3202461 129.905,35.3202461 C128.434162,35.3202461 127.105601,36.1989677 126.53,37.5525"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M115.28,37.5525 C114.704399,36.1989677 113.375838,35.3202461 111.905,35.3202461 C110.434162,35.3202461 109.105601,36.1989677 108.53,37.5525"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <circle
                id="Oval"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                cx="107.9675"
                cy="44.865"
                r="2.8125" />
              <circle
                id="Oval"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                cx="133.8425"
                cy="44.865"
                r="2.8125" />
              <rect
                id="Rectangle"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                x="99.5075"
                y="105.0075"
                width="42.75"
                height="19.125" />
              <rect
                id="Rectangle"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linejoin="round"
                x="99.5075"
                y="105.0075"
                width="42.75"
                height="19.125" />
              <rect
                id="Rectangle"
                class="stroke fill-light"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linejoin="round"
                x="97.2575"
                y="99.3825"
                width="47.25"
                height="5.625"
                rx="2.25" />
              <path
                id="Path"
                d="M142.2575,107.2575 C142.2575,113.470703 137.220703,118.5075 131.0075,118.5075 L126.5075,118.5075 C123.400898,118.5075 120.8825,121.025898 120.8825,124.1325 C120.8825,127.239102 123.400898,129.7575 126.5075,129.7575 L131.0075,129.7575 C143.433907,129.7575 153.5075,119.683907 153.5075,107.2575 L142.2575,107.2575 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M99.5075,107.2575 C99.5075,113.470703 104.544297,118.5075 110.7575,118.5075 L115.2575,118.5075 C118.364102,118.5075 120.8825,121.025898 120.8825,124.1325 C120.8825,127.239102 118.364102,129.7575 115.2575,129.7575 L110.7575,129.7575 C98.3310931,129.7575 88.2575,119.683907 88.2575,107.2575 L99.5075,107.2575 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M143.9675,96.885 C144.038155,97.5233161 143.832678,98.1614034 143.402821,98.638544 C142.972965,99.1156845 142.359703,99.3863985 141.7175,99.3825415 L117.5075,99.3825415 C116.865297,99.3863985 116.252035,99.1156845 115.822179,98.638544 C115.392322,98.1614034 115.186845,97.5233161 115.2575,96.885 L117.0125,72.3825 C117.149803,71.2463286 118.118092,70.3942338 119.2625,70.4024404 L139.985,70.4024404 C141.129408,70.3942338 142.097697,71.2463286 142.235,72.3825 L143.9675,96.885 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M143.9675,96.885 C144.038155,97.5233161 143.832678,98.1614034 143.402821,98.638544 C142.972965,99.1156845 142.359703,99.3863985 141.7175,99.3825415 L117.5075,99.3825415 C116.865297,99.3863985 116.252035,99.1156845 115.822179,98.638544 C115.392322,98.1614034 115.186845,97.5233161 115.2575,96.885 L117.0125,72.3825 C117.149803,71.2463286 118.118092,70.3942338 119.2625,70.4024404 L139.985,70.4024404 C141.129408,70.3942338 142.097697,71.2463286 142.235,72.3825 L143.9675,96.885 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M125.3825,74.6325 L125.3825,65.6325 C125.3825,63.1472186 127.397219,61.1325 129.8825,61.1325 C132.367781,61.1325 134.3825,63.1472186 134.3825,65.6325 L134.3825,74.6325"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <rect
                id="Rectangle"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero"
                x="98.3825"
                y="88.1325"
                width="21.375"
                height="11.25" />
              <rect
                id="Rectangle"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linejoin="round"
                x="98.3825"
                y="88.1325"
                width="21.375"
                height="11.25" />
              <rect
                id="Rectangle"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linejoin="round"
                x="97.2575"
                y="82.5075"
                width="23.625"
                height="5.625"
                rx="2.25" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
